// Copyright 2020 Cartesi Pte. Ltd.
// Licensed under the Apache License, Version 2.0 (the "License"); you may not
// use this file except in compliance with the License. You may obtain a copy
// of the license at http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
// License for the specific language governing permissions and limitations
// under the License.
export class GameConstants {
}
// version: v0.month.day.hour
GameConstants.VERSION = 'v0.9.30.11';
GameConstants.RELOAD_BASE_TICKS = 10;
GameConstants.BULLET_SPEED = 0.85; // in cells / tick
GameConstants.MORTAR_SPEED = 0.45;
GameConstants.INITIAL_TICKS_WAVE = 4;
GameConstants.ENEMY_SPAWNING_DELTA_TICKS = 10;
GameConstants.INITIAL_CREDITS = 500;
GameConstants.INITIAL_LIFES = 20;
// enemies names
GameConstants.ENEMY_SOLDIER = 'soldier';
GameConstants.ENEMY_RUNNER = 'runner';
GameConstants.ENEMY_HEALER = 'healer';
GameConstants.ENEMY_BLOB = 'blob';
GameConstants.ENEMY_FLIER = 'flier';
// turrets names
GameConstants.TURRET_PROJECTILE = 'projectile';
GameConstants.TURRET_LASER = 'laser';
GameConstants.TURRET_LAUNCH = 'launch';
GameConstants.TURRET_GLUE = 'glue';
// turret attributes
GameConstants.ATTRIBUTE_DAMAGE = 'damage';
GameConstants.ATTRIBUTE_RELOAD = 'reload';
GameConstants.ATTRIBUTE_RANGE = 'range';
GameConstants.ATTRIBUTE_EXPLOSION_RANGE = 'explosionRange';
GameConstants.ATTRIBUTE_INTENSITY = 'intensity';
GameConstants.ATTRIBUTE_DURATION = 'duration';
GameConstants.ATTRIBUTE_PRICE_IMPROVEMENT = 'priceImprovement';
GameConstants.ATTRIBUTE_PRICE_UPGRADE = 'priceUpgrade';
GameConstants.ATTRIBUTE_TELEPORT_DISTANCE = 'teleportDistance';
// action types
GameConstants.ACTION_TYPE_NEXT_WAVE = 'next wave';
GameConstants.ACTION_TYPE_ADD_TURRET = 'add turret';
GameConstants.ACTION_TYPE_SELL_TURRET = 'sell turret';
GameConstants.ACTION_TYPE_UPGRADE_TURRET = 'upgrade turret';
GameConstants.ACTION_TYPE_LEVEL_UP_TURRET = 'level up turret';
GameConstants.ACTION_TYPE_CHANGE_STRATEGY_TURRET = 'change strategy turret';
GameConstants.ACTION_TYPE_CHANGE_FIXED_TARGET_TURRET = 'change fixed target turret';
// shooting strategy
GameConstants.STRATEGY_SHOOT_FIRST = 'first';
GameConstants.STRATEGY_SHOOT_LAST = 'last';
GameConstants.STRATEGY_SHOOT_CLOSEST = 'closest';
GameConstants.STRATEGY_SHOOT_WEAKEST = 'weakest';
GameConstants.STRATEGY_SHOOT_STRONGEST = 'strongest';
GameConstants.STRATEGIES_ARRAY = [
    GameConstants.STRATEGY_SHOOT_FIRST,
    GameConstants.STRATEGY_SHOOT_LAST,
    GameConstants.STRATEGY_SHOOT_CLOSEST,
    GameConstants.STRATEGY_SHOOT_WEAKEST,
    GameConstants.STRATEGY_SHOOT_STRONGEST
];
// enemy attributes
GameConstants.HEALER_HEALING_TICKS = 200;
GameConstants.HEALER_STOP_TICKS = 5;
GameConstants.HEALER_HEALING_RADIUS = 2;
GameConstants.DIFFICULTY_MODIFIER = 8e-4;
GameConstants.DIFFICULTY_EXPONENT = 1.9;
GameConstants.DIFFICULTY_LINEAR = 20;
GameConstants.MIN_HEALTH_MODIFIER = 0.5;
GameConstants.REWARD_MODIFIER = 0.4;
GameConstants.REWARD_EXPONENT = 0.5;
GameConstants.MIN_REWARD_MODIFIER = 1;
GameConstants.EARLY_BONUS_MODIFIER = 3;
GameConstants.EARLY_BONUS_EXPONENT = 0.6;
GameConstants.WEAK_AGAINST_DAMAGE_MODIFIER = 3.0;
GameConstants.STRONG_AGAINST_DAMAGE_MODIFIER = 0.33;
// error types
GameConstants.ERROR_VERSION_MISMATCH = 'E001';
GameConstants.ERROR_NO_GAME_OVER = 'E002';
GameConstants.ERROR_TICKS = 'E003';
GameConstants.ERROR_ACTION_ARRAY = 'E004';
GameConstants.ERROR_ACTION_TYPE = 'E005';
GameConstants.ERROR_ACTION_VALUE = 'E006';
GameConstants.ERROR_TURRET = 'E007';
GameConstants.ERROR_CREDITS = 'E008';
GameConstants.ERROR_NEXT_WAVE = 'E009';
GameConstants.ERROR_ADD_TURRET_POSITION = 'E010';
GameConstants.ERROR_ADD_TURRET_NAME = 'E011';
GameConstants.ERROR_UPGRADE = 'E012';
GameConstants.ERROR_LEVEL_UP = 'E013';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiR2FtZUNvbnN0YW50cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvR2FtZUNvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxtQ0FBbUM7QUFFbkMsOEVBQThFO0FBQzlFLDZFQUE2RTtBQUM3RSwrREFBK0Q7QUFFL0Qsc0VBQXNFO0FBQ3RFLDRFQUE0RTtBQUM1RSwyRUFBMkU7QUFDM0UsMEVBQTBFO0FBQzFFLHFCQUFxQjtBQUVyQixNQUFNLE9BQU8sYUFBYTs7QUFDdEIsNkJBQTZCO0FBQ04scUJBQU8sR0FBRyxZQUFZLENBQUM7QUFFdkIsK0JBQWlCLEdBQUcsRUFBRSxDQUFDO0FBQ3ZCLDBCQUFZLEdBQUcsSUFBSSxDQUFDLENBQUMsa0JBQWtCO0FBQ3ZDLDBCQUFZLEdBQUcsSUFBSSxDQUFDO0FBQ3BCLGdDQUFrQixHQUFHLENBQUMsQ0FBQztBQUN2Qix3Q0FBMEIsR0FBRyxFQUFFLENBQUM7QUFDaEMsNkJBQWUsR0FBRyxHQUFHLENBQUM7QUFDdEIsMkJBQWEsR0FBRyxFQUFFLENBQUM7QUFFMUMsZ0JBQWdCO0FBQ08sMkJBQWEsR0FBRyxTQUFTLENBQUM7QUFDMUIsMEJBQVksR0FBRyxRQUFRLENBQUM7QUFDeEIsMEJBQVksR0FBRyxRQUFRLENBQUM7QUFDeEIsd0JBQVUsR0FBRyxNQUFNLENBQUM7QUFDcEIseUJBQVcsR0FBRyxPQUFPLENBQUM7QUFFN0MsZ0JBQWdCO0FBQ08sK0JBQWlCLEdBQUcsWUFBWSxDQUFDO0FBQ2pDLDBCQUFZLEdBQUcsT0FBTyxDQUFDO0FBQ3ZCLDJCQUFhLEdBQUcsUUFBUSxDQUFDO0FBQ3pCLHlCQUFXLEdBQUcsTUFBTSxDQUFDO0FBRTVDLG9CQUFvQjtBQUNHLDhCQUFnQixHQUFHLFFBQVEsQ0FBQztBQUM1Qiw4QkFBZ0IsR0FBRyxRQUFRLENBQUM7QUFDNUIsNkJBQWUsR0FBRyxPQUFPLENBQUM7QUFDMUIsdUNBQXlCLEdBQUcsZ0JBQWdCLENBQUM7QUFDN0MsaUNBQW1CLEdBQUcsV0FBVyxDQUFDO0FBQ2xDLGdDQUFrQixHQUFHLFVBQVUsQ0FBQztBQUNoQyx5Q0FBMkIsR0FBRyxrQkFBa0IsQ0FBQztBQUNqRCxxQ0FBdUIsR0FBRyxjQUFjLENBQUM7QUFDekMseUNBQTJCLEdBQUcsa0JBQWtCLENBQUM7QUFFeEUsZUFBZTtBQUNRLG1DQUFxQixHQUFHLFdBQVcsQ0FBQztBQUNwQyxvQ0FBc0IsR0FBRyxZQUFZLENBQUM7QUFDdEMscUNBQXVCLEdBQUcsYUFBYSxDQUFDO0FBQ3hDLHdDQUEwQixHQUFHLGdCQUFnQixDQUFDO0FBQzlDLHlDQUEyQixHQUFHLGlCQUFpQixDQUFDO0FBQ2hELGdEQUFrQyxHQUNyRCx3QkFBd0IsQ0FBQztBQUNOLG9EQUFzQyxHQUN6RCw0QkFBNEIsQ0FBQztBQUVqQyxvQkFBb0I7QUFDRyxrQ0FBb0IsR0FBRyxPQUFPLENBQUM7QUFDL0IsaUNBQW1CLEdBQUcsTUFBTSxDQUFDO0FBQzdCLG9DQUFzQixHQUFHLFNBQVMsQ0FBQztBQUNuQyxvQ0FBc0IsR0FBRyxTQUFTLENBQUM7QUFDbkMsc0NBQXdCLEdBQUcsV0FBVyxDQUFDO0FBRXZDLDhCQUFnQixHQUFHO0lBQ3RDLGFBQWEsQ0FBQyxvQkFBb0I7SUFDbEMsYUFBYSxDQUFDLG1CQUFtQjtJQUNqQyxhQUFhLENBQUMsc0JBQXNCO0lBQ3BDLGFBQWEsQ0FBQyxzQkFBc0I7SUFDcEMsYUFBYSxDQUFDLHdCQUF3QjtDQUN6QyxDQUFDO0FBRUYsbUJBQW1CO0FBQ0ksa0NBQW9CLEdBQUcsR0FBRyxDQUFDO0FBQzNCLCtCQUFpQixHQUFHLENBQUMsQ0FBQztBQUN0QixtQ0FBcUIsR0FBRyxDQUFDLENBQUM7QUFFMUIsaUNBQW1CLEdBQUcsSUFBSSxDQUFDO0FBQzNCLGlDQUFtQixHQUFHLEdBQUcsQ0FBQztBQUMxQiwrQkFBaUIsR0FBRyxFQUFFLENBQUM7QUFDdkIsaUNBQW1CLEdBQUcsR0FBRyxDQUFDO0FBQzFCLDZCQUFlLEdBQUcsR0FBRyxDQUFDO0FBQ3RCLDZCQUFlLEdBQUcsR0FBRyxDQUFDO0FBQ3RCLGlDQUFtQixHQUFHLENBQUMsQ0FBQztBQUN4QixrQ0FBb0IsR0FBRyxDQUFDLENBQUM7QUFDekIsa0NBQW9CLEdBQUcsR0FBRyxDQUFDO0FBRTNCLDBDQUE0QixHQUFHLEdBQUcsQ0FBQztBQUNuQyw0Q0FBOEIsR0FBRyxJQUFJLENBQUM7QUFFN0QsY0FBYztBQUNTLG9DQUFzQixHQUFHLE1BQU0sQ0FBQztBQUNoQyxnQ0FBa0IsR0FBRyxNQUFNLENBQUM7QUFDNUIseUJBQVcsR0FBRyxNQUFNLENBQUM7QUFDckIsZ0NBQWtCLEdBQUcsTUFBTSxDQUFDO0FBQzVCLCtCQUFpQixHQUFHLE1BQU0sQ0FBQztBQUMzQixnQ0FBa0IsR0FBRyxNQUFNLENBQUM7QUFDNUIsMEJBQVksR0FBRyxNQUFNLENBQUM7QUFDdEIsMkJBQWEsR0FBRyxNQUFNLENBQUM7QUFDdkIsNkJBQWUsR0FBRyxNQUFNLENBQUM7QUFDekIsdUNBQXlCLEdBQUcsTUFBTSxDQUFDO0FBQ25DLG1DQUFxQixHQUFHLE1BQU0sQ0FBQztBQUMvQiwyQkFBYSxHQUFHLE1BQU0sQ0FBQztBQUN2Qiw0QkFBYyxHQUFHLE1BQU0sQ0FBQyJ9